import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const extractVariables = (text: string): string[] => {
  const regex = /\{\{([^}]+)\}\}/g;
  const matches = text.match(regex);
  if (!matches) return [];

  return matches.map(
    (match) => match.slice(2, -2).trim(), // Remove {{ }} and trim whitespace
  );
};
